import React from 'react';
import { Link } from 'react-router-dom';
import CoupleItem from './CoupleItem';
import { CoupleItemWrapper } from './CoupleItemStyle';

import { IcoupleDetailItem } from '@typings/couple/couple.interface';
import CoupleCard from './CoupleCard';
import StaggerMotionWrapper from '@components/wrapper/StaggerMotionWrapper';
import {
  PAGE_LAYOUT_TYPE,
  PAGE_LAYOUT_TYPE_VALUE,
} from '@typings/pages/pageLayout.interface';

type Props = {
  isEdit: boolean;
  data: IcoupleDetailItem[];
  collectionPath: string;
  boardType: PAGE_LAYOUT_TYPE_VALUE;
  line: number;
};
function CoupleList({ isEdit, data, collectionPath, boardType, line }: Props) {
  if (!data) return null;

  return (
    <StaggerMotionWrapper
      line={boardType === PAGE_LAYOUT_TYPE.ONELINE ? 1 : line}
      style={{ width: '100%' }}
    >
      {data!.map((list, i) => {
        const ListMap = {
          [PAGE_LAYOUT_TYPE.ONELINE]: (
            <CoupleItemWrapper key={list.id || i}>
              <Link to={`${list.id}`}>
                <CoupleItem
                  data={list}
                  collectionPath={collectionPath}
                  isEdit={isEdit}
                />
              </Link>
            </CoupleItemWrapper>
          ),
          [PAGE_LAYOUT_TYPE.EXTEND]: (
            <Link key={list.id || i} to={`${list.id}`}>
              <CoupleCard
                data={list}
                collectionPath={collectionPath}
                isEdit={isEdit}
              />
            </Link>
          ),
        };

        return ListMap[boardType];
      })}
    </StaggerMotionWrapper>
  );
}

export default CoupleList;
